import { ReactNode } from "react";

import { PortalClassesEnum } from "@/ts/enums/PortalClassesEnum";
import { getTrackingId } from "@/utils/utils";

import { MenuItem } from "@chakra-ui/react";

interface ProfileMenuItemProps {
    value: string;
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
    children: ReactNode;
    "data-testid"?: string;
    color?: string;
    dataTrackingId?: string;
}

const ProfileMenuItem = ({
    value,
    onClick,
    children,
    color = "gray.600",
    "data-testid": dataTestId,
    dataTrackingId
}: ProfileMenuItemProps) => {
    return (
        <MenuItem
            value={value}
            data-testid={dataTestId}
            data-tracking-id={
                dataTrackingId ??
                getTrackingId(
                    [
                        PortalClassesEnum.ProfileMenuItem,
                        PortalClassesEnum.MenuItem
                    ],
                    value
                )
            }
            padding="0.5rem 0.75rem"
            fontWeight="500"
            color={color}
            bg="transparent"
            borderRadius="6px"
            margin="2px 0"
            transition="all 0.2s ease"
            position="relative"
            _hover={{
                bg: "base.100",
                color: "base.800",
                _dark: {
                    bg: "base.700",
                    color: "gray.200"
                }
            }}
            _active={{
                color: "base.800",
                _dark: { color: "gray.200" }
            }}
            _dark={{
                color: "gray.300"
            }}
            onClick={onClick}
            fontSize="1rem"
        >
            {children}
        </MenuItem>
    );
};

export default ProfileMenuItem;
